import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { matIconIconFormat } from '../post-type-editor.component';

@Component({
  selector: 'app-loop-post-type-icon-settings',
  styleUrls: ['./post-type-icon-settings.component.scss'],
  templateUrl: './post-type-icon-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PostTypeIconSettingsComponent implements OnInit {
  @Input() parentForm: UntypedFormGroup;
  customTypes: UntypedFormArray;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.customTypes = this.parentForm.get('iconResource').get('customTypes') as UntypedFormArray;
  }

  addCustomType(event): void {
    event.preventDefault();
    this.customTypes.push(
      this.fb.group({
        type: [''],
        icon: this.fb.group({
          format: [matIconIconFormat],
          value: ['', Validators.required],
        }),
      }),
    );
  }

  removeCustomType(event, index): void {
    event.preventDefault();
    this.customTypes.removeAt(index);
  }
}
